export default Object.freeze({
  Success: 0,
  Warning: 1,
  Error: 2,
});
